import { SsoAcceptActionTypes } from './ssoAccept.types';

const request = payload => ({
  type: SsoAcceptActionTypes.REQUEST,
  payload,
});

const success = () => ({
  type: SsoAcceptActionTypes.SUCCESS,
});

const failure = error => ({
  type: SsoAcceptActionTypes.FAILURE,
  payload: { error },
});

const ssoAcceptActions = {
  request,
  success,
  failure,
};

export default ssoAcceptActions;
